// ui/ReadyCountdown.jsx: B2-5/B2-7/B2-8 ticking ready countdown.
//
// Renders "Next hand in 23 s" (or a caller-supplied prefix) from the
// server's ready_deadline_server_ts, corrected by the clock offset like
// TurnTimerRing. Ticks on a 500 ms interval; unmounts to nothing without
// a deadline. B2-fix8: the text comes from the tested helpers
// (readyCountdownText / lobbyCountdownText) so the clock-offset sign the
// unit tests pin is the sign production renders.

import { useEffect, useState } from 'preact/hooks';
import { readyCountdownText } from './end-of-hand.js';
import { lobbyCountdownText } from './game-over.js';

/**
 * @param {{
 *   deadlineMs: number|null|undefined,
 *   clockOffsetMs?: number,
 *   prefix?: string,
 *   now?: () => number,
 * }} props
 */
export function ReadyCountdown({ deadlineMs, clockOffsetMs = 0, prefix = 'Next hand in', now = Date.now }) {
  const [, setTick] = useState(0);
  useEffect(() => {
    if (deadlineMs == null) return undefined;
    const timer = setInterval(() => setTick((n) => n + 1), 500);
    return () => clearInterval(timer);
  }, [deadlineMs]);
  if (deadlineMs == null) return null;
  // B2-fix8: same text, same offset sign as the helpers —
  // server deadline minus (local now plus clockOffsetMs). The lobby
  // variant ("Back to lobby in") uses its own tested helper; any other
  // prefix reuses the ready helper's countdown with the prefix swapped.
  const helperText = prefix === 'Back to lobby in'
    ? lobbyCountdownText(deadlineMs, now(), clockOffsetMs)
    : readyCountdownText(deadlineMs, now(), clockOffsetMs);
  if (helperText == null) return null;
  const text = prefix === 'Back to lobby in' || prefix === 'Next hand in'
    ? helperText
    : helperText.replace(/^Next hand in/, prefix);
  return (
    <div class="ready-countdown" data-testid="ready-countdown" role="timer">
      {text}
    </div>
  );
}
